import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { w, v } from '@dojo/framework/core/vdom';
import { DNode, WidgetProperties } from '@dojo/framework/core/interfaces';

import css from '../css/lptool.m.css';

export interface LPToolbarProperties {
	classes?: string[];
	name: string;
	element?: string;
	kids: LPToolbarKid[];
}

export interface LPToolbarKid {
	widget: string;
	name?: string;
	element?: string;
}

@theme(css)
export class LPToolbar extends I18nThemed<LPToolbarProperties> {
	protected render_kids(kids: LPToolbarKid[]): DNode[] {
		return kids.map((kid) => {
			const { widget } = kid;
			const params: Partial<LPToolbarKid> = { ...kid };
			delete params['widget'];
			return w(widget, { ...params } as any as WidgetProperties);
		});
	}

	protected render(): DNode {
		const { classes = [], name, element = 'ul', kids } = this.properties;

		return v(
			element,
			{
				key: name,
				role: 'menubar',
				classes: [this.theme(css.root), ...classes],
				xqa: `lptool ${name}`,
				onclick: (evt) => {
					evt && evt.stopPropagation();
				}
			},
			this.render_kids(kids)
		);
	}
}

export default LPToolbar;
